// extracted by mini-css-extract-plugin
module.exports = {"divider":"Conversation_divider__RG8o7","row":"Conversation_row__3_uyx","video":"Conversation_video__GYfIi","error":"Conversation_error__37h95"};